module.exports = __webpack_public_path__ + "img/org.cddf584a.jpg";